/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React from 'react';
import { useDdf } from '../../context/ddf-context';

const LoadMore = ({ customLabel = 'Load more' }) => {
  const { handlers } = useDdf();

  const showMore = Boolean(handlers.showMore && handlers.showMore());

  return (
    <div className="flex mt-3 justify-center">
      {showMore && (
        <button
          className="text-primary-500 font-bold cursor-pointer"
          onClick={() => handlers.loadMoreHandler && handlers.loadMoreHandler()}
        >
          {customLabel}
        </button>
      )}
    </div>
  );
};

export default LoadMore;
